<template>
  <div class="mes-outer-wrap">
    <div :class="isReadOnly ? 'readonly-info-wrap' : ''">
      <el-row>
        <el-col :span="2">毕业学校{{ schoolNum+1 }}:</el-col>
        <el-col :span="5">
          <jm-Search
            v-if="!isReadOnly"
            clearable
            class="jm-input-common4"
            v-model="obj"
            get-value="school"
            :get-other-value="['school_type', 'wangda']"
            get-type="sh_name_cn"
            :getother-type="['school_type', 'sh_order']"
            get-url='/index/api_base/searchGSchool'/>
          <span v-else>{{ obj.school }}</span>
        </el-col>
        <el-col :span="4" v-if="!isReadOnly">
          <span class="errors" v-if="obj.school==='' && errors.has('gschoolname')" >*{{ errors.first('gschoolname') }}</span>
          <span class="errors" v-if="obj.school==='' && !errors.has('gschoolname')" >*请输入毕业学校</span>
          <input
            style="display: none;"
            name="gschoolname"
            v-model="obj.school">
        </el-col>
        <el-col :span="2">
          学校类型:
        </el-col>
        <el-col :span="5">
          <jm-dict-select
            class="jm-input-common4"
            clearable
            type="jiemo"
            v-model="obj.school_type"
            dict-type="offer_school_type"
            :show="isReadOnly"
            name="schoolType" />
        </el-col>
        <el-col :span="6" v-if="!isReadOnly">
          <span class="errors" v-if="obj.school_type=== '' && errors.has('schoolType')" >*{{ errors.first('schoolType') }}</span>
          <span class="errors" v-if="obj.school_type=== '' && !errors.has('schoolType')" >*请输入学校类型</span>
          <input
            style="display: none;"
            name="schoolType"
            v-model="obj.school_type">
        </el-col>
      </el-row>
      <el-row class="prompting-wapper">
        <el-col :span="2">
          网大排名:
        </el-col>
        <el-col :span="5">
          <el-input :readonly="isReadOnly" class="jm-input-common4" v-model="obj.wangda" :placeholder="isReadOnly? '' : '请输入内容'"/>
        </el-col>
        <el-col :span="17" v-if="canSave">
          <el-button
            v-if="!isReadOnly"
            type="primary"
            size="medium"
            @click="addNewmajor">添加专业</el-button>
          <el-button
            type="primary"
            @click="clearSchool(schoolNum)"
            v-if="schoolarr.length > 1 && !isReadOnly">删除学校</el-button>
        </el-col>
      </el-row>
      <div
        class="major-wapper"
        v-for="(num, index) in obj.pro_list"
        :key="index">
        <el-row>
          <el-col :span="2">
            专业名称{{ index+1 }}:
          </el-col>
          <el-col :span="5">
            <jm-Search
              v-if="!isReadOnly"
              clearable
              class="jm-input-common4"
              v-model="obj.pro_list[index]"
              get-value="major"
              get-other-value="professional_ower"
              get-type="value"
              getother-type="pid"
              get-list="value"
              get-url='/index/api_base/serachGProfessional'/>
            <span v-else>{{ obj.pro_list[index].major }}</span>
          </el-col>
          <el-col :span="4" v-if="!isReadOnly">
            <input
              class="hideIpt"
              style="display: none;"
              :name="'gmajorName'+schoolNum+index"
              v-model="num.major">
            <span class="errors" v-if="num.major==='' && errors.has(`gmajorName${schoolNum}${index}`)" >*{{ errors.first(`gmajorName${schoolNum}${index}`) }}</span>
            <span class="errors" v-if="num.major==='' && !errors.has(`gmajorName${schoolNum}${index}`)">*请输入专业</span>
          </el-col>
          <el-col :span="2">
            专业方向:
          </el-col>
          <el-col :span="5">
            <jm-dict-select
              v-model="num.professional_ower"
              value-type="string"
              empty-label="请选择"
              type="jiemo"
              clearable
              class="jm-input-common4"
              :show="isReadOnly"
              dict-type="graduated_professionals"/>
          </el-col>
          <el-col :span="6" v-if="!isReadOnly">
            <input
              style="display: none;"
              :name="'professionalOwer'+schoolNum+index"
              v-model="num.professional_ower">
            <span class="errors" v-if="num.professional_ower==='' || num.professional_ower===null &&errors.has(`gmajordir${schoolNum}${index}`)" >*{{ errors.first(`gmajordir${schoolNum}${index}`) }}</span>
            <span class="errors" v-if="num.professional_ower==='' && !errors.has(`gmajordir${schoolNum}${index}`)" >请输入专业方向</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            学位类型:
          </el-col>
          <el-col :span="5">
            <jm-dict-select
              v-model="num.master_type"
              clearable
              type="jiemo"
              value-type="string"
              empty-label="请选择"
              class="jm-input-common4"
              :show="isReadOnly"
              dict-type="master_type"/>
          </el-col>
          <el-col :span="17">
            <el-button
              type="primary"
              @click="clearMajor(num.id, num.school_id, index)"
              v-if="obj.pro_list.length > 1 && !isReadOnly">删除专业{{ index + 1 }}</el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            GPA分数:
          </el-col>
          <el-col :span="3">
            <el-input
              @blur="jidian(num.gpa_suanshu, num.gpa_jidian, index)"
              :name="'gpaSuanshu'+schoolNum+index"
              class="jm-input-common4"
              v-model="num.gpa_suanshu"
              :readonly="isReadOnly"
              placeholder="算数平均分"/>
          </el-col>
          <el-col :span="3">
            <el-input
              :name="'gpaJiaquan'+schoolNum+index"
              class="jm-input-common4"
              v-model="num.gpa_jiaquan"
              :readonly="isReadOnly"
              placeholder="加权平均分"/>
          </el-col>
          <el-col :span="3">
            <el-input
              @blur="suanshu(num.gpa_jidian, num.gpa_suanshu, index)"
              :name="'gpaJidian'+schoolNum+index"
              class="jm-input-common4"
              v-model="num.gpa_jidian"
              :readonly="isReadOnly"
              placeholder="绩点"/>
          </el-col>
          <el-col :span="4">
            <el-popover
              placement="right"
              width="200"
              trigger="hover"
              content="包括所有课程的成绩(包括选修),只要是成绩单上的课程都要计算">
              <el-button
                v-if="!isReadOnly"
                slot="reference"
                class="help-button">?</el-button>
            </el-popover>
            <el-radio
              class="radio"
              :name="'gpaRadio'+schoolNum"
              v-model="num.use_status"
              :readonly="isReadOnly"
              :label="schoolNum + '' + index">优先使用此GPA</el-radio>
          </el-col>
          <el-col :span="9" v-if="!isReadOnly">
            <span class="errors" v-if="num.gpa_suanshu === '' && num.gpa_jiaquan === '' && num.gpa_jidian === ''">*GPA项目至少添加一项</span>&ensp;
            <span class="errors" v-if="errors.has(`gpaSuanshu${schoolNum}${index}`)" >*{{ errors.first(`gpaSuanshu${schoolNum}${index}`) }}</span>&ensp;
            <span class="errors" v-if="errors.has(`gpaJiaquan${schoolNum}${index}`)" >*{{ errors.first(`gpaJiaquan${schoolNum}${index}`) }}</span>&ensp;
            <span class="errors" v-if="errors.has(`gpaJidian${schoolNum}${index}`)" >*{{ errors.first(`gpaJidian${schoolNum}${index}`) }}</span>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import { jmSearch, jmSchoolSearch, jmAreaselect, jmChannel, jmEducationSelect, jmDictSelect } from '@/components/tool';
import { Validator } from 'vee-validate';

export default {
  props: {
    schoolNum: {
      type: Number,
    },
    obj: {
      type: Object,
      default: null
    },
    schoolarr: {
      type: Array,
    },
    isRadios: {
      type: String
    },
    crmId: {
      type: Number
    },
    rules: {
      type: Object
    },
    isGschools: {
      type: Boolean
    },
    isQueren: {
      type: Number
    },
    canSave: {
      type: Boolean,
      default: true
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      input: '',
      value: '',
      nameAndType: {},
      majorsAnddirection: [],
      majorList: [{
        id: '',
        school_id: '',
        school: '',
        master_type: '',
        crm_id: '',
        major: null,
        professional_ower: null,
        gpa_suanshu: '',
        gpa_jiaquan: '',
        gpa_jidian: '',
        pid: ''
      }],
      emailsDB: [],
      email: null,
      gmajorName: {}, // 专业
      gmajordir: {}, // 方向
      gpaSuanshu: {}, // GPA算数
      gpaJiaquan: {}, // GPA加权
      gpaJidian: {} // GPA绩点
    };
  },
  methods: {
    jidian(val, oval, index) {
      let x = val / 25;
      if (oval === '') {
        if (val !== '') {
          this.obj.pro_list[index].gpa_jidian = Math.round(x * 100) / 100;
        }
      }
    },
    suanshu(val, oval, index) {
      let x = val * 25;
      if (oval === '') {
        if (val !== '') {
          this.obj.pro_list[index].gpa_suanshu = Math.round(x * 100) / 100;
        }
      }
    },
    checkAll() {
      this.$validator.validateAll().then((result) => {
        this.obj.iscan = result;
        if (this.obj.pro_list && this.obj.pro_list.length > 0) {
          this.obj.pro_list.forEach((item) => {
            if (item.gpa_suanshu === '' && item.gpa_jiaquan === '' && item.gpa_jidian === '') {
              this.obj.iscan = false;
            }
          });
        }
      });
    },
    addNewmajor() {
      if (!this.obj.pro_list) {
        this.obj.pro_list = [];
      }
      this.obj.pro_list.push(this.pushList());
    },
    pushList() {
      return Object.assign({}, {
        id: '',
        school_id: '',
        school: '',
        master_type: '',
        crm_id: '',
        major: '',
        professional_ower: '',
        gpa_suanshu: '',
        gpa_jiaquan: '',
        gpa_jidian: '',
        pid: '',
      });
    },
    clearMajor(id, schoolId, index) {
      this.$confirm('此操作将永久删除该学生该毕业专业的信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (id !== '' || id) {
          // 删除学校借口 crm_id 学校对应的id 后台传的可以用请求删除
          this.$http._post({
            url: 'index/student/delGProfessional',
            data: {
              crm_id: this.crmId,
              sh_id: schoolId,
              id: id
            }
          }).then((data) => {
            if (data) {
              this.$message.success('删除成功');
              this.obj.pro_list.splice(index, 1);
            }
          });
        } else {
          this.$message.success('删除成功');
          this.obj.pro_list.splice(index, 1);
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    gschools() {
      // 新增毕业学校结构
      return {
        id: null,
        crm_id: '',
        school: '',
        school_type: '4',
        wangda: '',
        iscan: true,
        pro_list: [
          {
            id: '',
            school_id: '',
            school: '',
            master_type: 0,
            crm_id: '',
            major: '',
            professional_ower: '',
            gpa_suanshu: '',
            gpa_jiaquan: '',
            gpa_jidian: '',
            use_status: 0
          }
        ]
      };
    },

    clearSchool(index) {
      this.$confirm('此操作将永久删除该毕业学校信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.obj.id) {
          // 删除学校借口 crm_id 学校对应的id 后台传的可以用请求删除
          this.$http._post({
            url: 'index/student/delGSchool',
            data: {
              crm_id: this.crmId,
              id: this.obj.id
            }
          }).then((data) => {
            if (data) {
              this.schoolarr.splice(index, 1);
              this.$message.success('删除成功');
            }
          });
        } else {
          // 操控数据源数组
          this.schoolarr.splice(index, 1);
          this.$message.success('删除成功');
        }
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    isprolist () {
      if (this.obj.pro_list && this.obj.pro_list.length === 0) {
        this.obj.pro_list = this.majorList;
      }
      for (let i = 0; i < this.obj.pro_list.length; i++) {
        this.$set(this.gmajorName, `gmajorName${this.schoolNum}${i}`, '专业');
        this.$set(this.gmajordir, `gmajordir${this.schoolNum}${i}`, '专业方向');
        this.$set(this.gpaSuanshu, `gpaSuanshu${this.schoolNum}${i}`, '算数平均分');
        this.$set(this.gpaJiaquan, `gpaJiaquan${this.schoolNum}${i}`, '加权平均分');
        this.$set(this.gpaJidian, `gpaJidian${this.schoolNum}${i}`, '加权平均分');
      }
      this.yanzheng();
      for (let a = 0; a < this.majorList.length; a++) {
        this.majorsAnddirection.push({});
      }
    },
    yanzheng () {
      const dictionary = {
        zh_CN: {
          messages: {
            required: (field) => { return `请输入${field}`; },
            between: (filed, data) => { return `${filed}应该在${data[0]} 到 ${data[1]}之间`; },
            decimal: (filed, data) => { return `${filed}最多${data}小数`; }
          },
          attributes: {
            gschoolname: '毕业学校',
            schoolType: '学校类型',
            ...this.gmajorName,
            ...this.gmajordir,
            ...this.gpaSuanshu,
            ...this.gpaJiaquan,
            ...this.gpaJidian
          }
        }
      };
      Validator.localize(dictionary);
    },
    checkZeros() {
      this.obj.pro_list.forEach((item) => {
        if (item.gpa_suanshu === 0 || item.gpa_suanshu === '0') {
          item.gpa_suanshu = '';
        }
        if (item.gpa_jiaquan === 0 || item.gpa_jiaquan === '0') {
          item.gpa_jiaquan = '';
        }
        if (item.gpa_jidian === 0 || item.gpa_jidian === '0') {
          item.gpa_jidian = '';
        }
        if (item.master_type === 0 || item.master_type === '0') {
          item.master_type = '';
        }
        if (item.professional_ower === 0 || item.professional_ower === '0') {
          item.professional_ower = '';
        }
      });
      if (this.obj.school_type === 0 || this.obj.school_type === '0') {
        this.obj.school_type = '';
      }
    },
  },
  mounted () {
    this.checkZeros();
  },
  components: {
    jmAreaselect,
    jmChannel,
    jmEducationSelect,
    jmDictSelect,
    jmSchoolSearch,
    jmSearch,
    Validator
  },
  watch: {
    obj: {
      handler: function () {
        this.checkZeros();
      },
      deep: true
    },
    majorsAnddirection(val) {
      val.forEach((item, index) => {
        if (item.pid !== '') {
          this.majorList[index].professional_ower = val.pid;
          this.majorList[index].id = val.id;
          this.majorList[index].major = val.value;
        } else {
          this.majorList[index].professional_ower = null;
          this.majorList[index].id = '';
          this.majorList[index].major = '';
        }
      });
    },
    gmajorList: {
      handler: function (newN, oldVal) {
        for (let i = 0; i < this.obj.pro_list.length; i++) {
          if (newN[i] !== oldVal[i]) {
            newN[i] = newN[i] === '' || !newN[i] ? '没有选择' : newN[i];
            this.$set(this.gmajorName, `gmajorName${this.schoolNum}${i}`, '专业');
          }
          this.yanzheng(`gmajorName${this.schoolNum}${i}`);
        }
      },
      deep: true
    },
    suanshuList: {
      handler: function (newN, oldVal) {
        for (let i = 0; i < this.obj.pro_list.length; i++) {
          if (newN[i] !== oldVal[i]) {
            this.$set(this.gmajorName, `gpaSuanshu${this.schoolNum}${i}`, '算数平均分');
          }
          this.yanzheng(`gpaSuanshu${this.schoolNum}${i}`);
        }
      },
      deep: true
    },
    jiaquanList: {
      handler: function (newN, oldVal) {
        for (let i = 0; i < this.obj.pro_list.length; i++) {
          if (newN[i] !== oldVal[i]) {
            this.$set(this.gmajorName, `gpaJiaquan${this.schoolNum}${i}`, '算数平均分');
          }
          this.yanzheng(`gpaJiaquan${this.schoolNum}${i}`);
        }
      },
      deep: true
    },
    gpaJidianList: {
      handler: function (newN, oldVal) {
        for (let i = 0; i < this.obj.pro_list.length; i++) {
          if (newN[i] !== oldVal[i]) {
            this.$set(this.gmajorName, `gpaJidian${this.schoolNum}${i}`, '算数平均分');
          }
          this.yanzheng(`gpaJidian${this.schoolNum}${i}`);
        }
      },
      deep: true
    }
  },
  computed: {
    'num.gpa_suanshu': function(val) {
      return val * 2;
    },
    gmajorList: function() {
      let obj = {};
      if (this.obj.pro_list) {
        for (let i = 0; i < this.obj.pro_list.length; i++) obj[i] = this.obj.pro_list[i].major;
      }
      return obj;
    },
    suanshuList: function () {
      let obj = {};
      if (this.obj.pro_list) {
        for (let i = 0; i < this.obj.pro_list.length; i++) obj[i] = this.obj.pro_list[i].gpa_suanshu;
      }
      return obj;
    },
    jiaquanList: function () {
      let obj = {};
      if (this.obj.pro_list) {
        for (let i = 0; i < this.obj.pro_list.length; i++) obj[i] = this.obj.pro_list[i].gpa_jiaquan;
      }
      return obj;
    },
    gpaJidianList: function () {
      let obj = {};
      if (this.obj.pro_list) {
        for (let i = 0; i < this.obj.pro_list.length; i++) obj[i] = this.obj.pro_list[i].gpa_jidian;
      }
      return obj;
    }
  },
  created() {
    Validator.extend('gschoolname', {
      getMessage: (field) => { return `请输入${field}`; },
      validate: (value) => {
        let a = value.school !== '';
        return a;
      }
    });
    this.yanzheng();
  }
};
</script>
<style scoped>
  .mes-outer-wrap{
    width: 100%;
  }
  .mes-outer-wrap .first-line{
    display: none;
  }
  .mes-outer-wrap:nth-of-type(1) .first-line{
    display: block;
  }
  .jm-dict-select>div{
   width: 150px;
  }
  .radio{
   margin-left: 14px;
  }
  .school>div{
   width: 100%;
  }
  .prompting-wapper{
   line-height: 50px;
  }
  .isgpa>.prompting-wapper{
   width: 110px;
   margin-right: 5px;
   height: auto;
  }
  .prompting-wapper::after{
   clear: both;
  }
  .mes-wapper {
   display: flex;
   align-items: center;
   /*margin: 8px;*/
   box-sizing: border-box;
   border-radius: 4px;
  }
  .annotation {
   color: #ff3f3f;
  }
  .mes-wapper span i {
   line-height: 200%;
  }
  .mes-wapper span {
   display: block;
   padding: 0 4px;
   font-size: 14px;
   white-space: nowrap;
   font-weight: bold;
  }
  .el-row .el-col{
   display: -webkit-box;
   display: -ms-flexbox;
   display: flex;
   -webkit-box-align: center;
   -ms-flex-align: center;
   align-items: center;
   min-height: 55px;
   padding:0 8px;
   border-right: solid 1px #f1f5ff;
   border-bottom: solid 1px #f1f5ff;
   font-size: 12px;
  }
  .el-row .el-col-1, .el-row .el-col-2 {
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    padding-right: 5px;
    padding-left: 0;
    font-size: 14px;
    color: #010D2D;
    font-weight: bold;
    text-align: right;
  }
  .errors{
    color: red;
  }
</style>
